export default __webpack_public_path__ + "static/media/soccer.36a2efaa.svg";